namespace GeniuzPOS.AdvPromo {
    export interface VwAdvPromoBasicAndAdvActiveByPluForm {
        PluCode: Serenity.StringEditor;
        PromoCampaign: Serenity.StringEditor;
        PmId: Serenity.StringEditor;
        PmGroupId: Serenity.StringEditor;
        PmGroupDesc: Serenity.StringEditor;
        PmType: Serenity.IntegerEditor;
        StartPromoDate: Serenity.DateEditor;
        EndPromoDate: Serenity.DateEditor;
        PromoTimeFg: Serenity.BooleanEditor;
        StartPromoTime: Serenity.StringEditor;
        EndPromoTime: Serenity.StringEditor;
        PromoDayFg: Serenity.IntegerEditor;
        PromoDay: Serenity.StringEditor;
        PromoShopFg: Serenity.IntegerEditor;
        PromoShop: Serenity.StringEditor;
        PromoCustFg: Serenity.IntegerEditor;
        PromoCust: Serenity.StringEditor;
        VenderSharing: Serenity.DecimalEditor;
    }

    export class VwAdvPromoBasicAndAdvActiveByPluForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.VwAdvPromoBasicAndAdvActiveByPlu';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!VwAdvPromoBasicAndAdvActiveByPluForm.init)  {
                VwAdvPromoBasicAndAdvActiveByPluForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(VwAdvPromoBasicAndAdvActiveByPluForm, [
                    'PluCode', w0,
                    'PromoCampaign', w0,
                    'PmId', w0,
                    'PmGroupId', w0,
                    'PmGroupDesc', w0,
                    'PmType', w1,
                    'StartPromoDate', w2,
                    'EndPromoDate', w2,
                    'PromoTimeFg', w3,
                    'StartPromoTime', w0,
                    'EndPromoTime', w0,
                    'PromoDayFg', w1,
                    'PromoDay', w0,
                    'PromoShopFg', w1,
                    'PromoShop', w0,
                    'PromoCustFg', w1,
                    'PromoCust', w0,
                    'VenderSharing', w4
                ]);
            }
        }
    }
}
